type ChannelLineProps = {
  channel: { centralFrequencyHz: string, bandwidth: string },
  offsetY: number,
  containerWidth: number;
  canvasWidthInHz: number;
  startFrequency: number;
}

const ChannelLine = ({ channel, offsetY, containerWidth, canvasWidthInHz, startFrequency }: ChannelLineProps) => {
  const centralFrequencyHz = parseInt(channel.centralFrequencyHz);
  const oneHzInPx = containerWidth / canvasWidthInHz;
  const centralFrequencyPosition = centralFrequencyHz * oneHzInPx - startFrequency * oneHzInPx;

  return (
    <line x1={centralFrequencyPosition} y1={offsetY + 10} x2={centralFrequencyPosition} y2={offsetY + 160} stroke='#007DFF' />
  )
}

export default ChannelLine;